import styled from 'styled-components';

import { AvatarContainer } from './Avatar.styled';

type Props = {
  $stacked?: boolean;
};

export const AvatarGroup = styled.div<Props>`
  display: flex;

  ${(props) =>
    props.$stacked
      ? `
      > ${AvatarContainer}:not(:first-child) {
          margin-inline-start: -10px; 
        }
    `
      : undefined}
`;
